var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.logged && !_vm.login)?_c('navbar'):_vm._e(),_c('main',{staticClass:"app-content"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('preloader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }